import { MessageBar, MessageBarType, Stack } from "@bps/fluent-ui";
import { useFeedbackContext } from "../libs/stores/feedback-context/feedback-context";
import { NotificationType } from "@bps/stores";

export const Notifications = () => {
  const { notifications, close } = useFeedbackContext();

  return (
    <Stack
      styles={{
        root: { position: "absolute", right: 260, top: 8, zIndex: 1000001 }
      }}
    >
      {notifications.map(x => (
        <MessageBar
          key={x.key}
          messageBarType={toMessageBarType(x.type)}
          dismissButtonAriaLabel="Close"
          onDismiss={() => {
            close(x.key);
          }}
        >
          {x.message}
        </MessageBar>
      ))}
    </Stack>
  );
};

const toMessageBarType = (notificationType: NotificationType) => {
  switch (notificationType) {
    case "error":
      return MessageBarType.error;
    case "info":
      return MessageBarType.info;
    case "success":
      return MessageBarType.success;
    case "warning": {
      return MessageBarType.warning;
    }
  }
};
